export const NAVIGATION_ITEMS = {
  DASHBOARD: {
    key: 'dashboard',
    label: 'Dashboard',
    icon: 'pi pi-home',
    path: '/dashboard',
    requiredMainUser: false,
  },
  BUSINESS_TAILORING: {
    key: 'business-tailoring',
    label: 'Tailoring',
    icon: 'pi pi-info-circle',
    path: '/business-tailoring',
    requiredMainUser: false,
  },
  CHAT_JOURNEY: {
    key: 'chat-journey',
    label: 'Chat Journey',
    icon: 'pi pi-sitemap',
    path: '/chat-journey',
    requiredMainUser: true,
  },
  ARTICLES: {
    key: 'articles',
    label: 'Articles',
    icon: 'pi pi-file-edit',
    path: '/articles',
    requiredMainUser: true,
  },
  // MAP: {
  //   key: 'map',
  //   label: 'Map',
  //   icon: 'pi pi-map',
  //   path: '/map',
  //   requiredMainUser: false,
  //   new: true,
  // },
  // LINKED_GMAIL: {
  //   key: 'linked-gmail',
  //   label: 'Register agent',
  //   icon: 'pi pi-users',
  //   path: '/linked-gmail',
  //   requiredMainUser: true,
  //   new: true,
  // },
  PRINT_QR: {
    key: 'print-qr',
    label: 'Print QR Code',
    icon: 'pi pi-print',
    path: null, // Function only
    requiredMainUser: false,
  },
  LOGOUT: {
    key: 'logout',
    label: 'Logout',
    icon: 'pi pi-power-off',
    path: null, // Function only
    requiredMainUser: false,
  },
};
